/**
 * Global state manager to avoid circular dependencies
 * This replaces the previous GlobalVars pattern
 */

// Global state container
const globalState = {
  broadcastChannel: null,
  $segment: null,
  $liveAgent: null,
  $zendeskInit: false,
  $cdn: null
}

// Getter functions
export const getGlobal = (key) => {
  return globalState[key]
}

export const getAllGlobals = () => {
  return { ...globalState }
}

// Setter functions
export const setGlobal = (key, value) => {
  globalState[key] = value
}

export const setMultipleGlobals = (updates) => {
  Object.assign(globalState, updates)
}

// Specific getters for commonly used items
export const getBroadcastChannel = () => globalState.broadcastChannel
export const getSegment = () => globalState.$segment
export const getLiveAgent = () => globalState.$liveAgent
export const getZendeskInit = () => globalState.$zendeskInit
export const getCdn = () => globalState.$cdn

// Specific setters for commonly used items  
export const setBroadcastChannel = (channel) => {
  globalState.broadcastChannel = channel
}

export const setSegment = (segment) => {
  globalState.$segment = segment  
}

export const setLiveAgent = (agent) => {
  globalState.$liveAgent = agent
}

export const setZendeskInit = (value) => {
  globalState.$zendeskInit = value
}

export const setCdn = (cdn) => {
  globalState.$cdn = cdn
}

// For backward compatibility, export a GlobalVars-like object
export const GlobalVars = {
  get broadcastChannel() { return globalState.broadcastChannel },
  set broadcastChannel(value) { globalState.broadcastChannel = value },
  
  get $segment() { return globalState.$segment },
  set $segment(value) { globalState.$segment = value },
  
  get $liveAgent() { return globalState.$liveAgent }, 
  set $liveAgent(value) { globalState.$liveAgent = value },
  
  get $zendeskInit() { return globalState.$zendeskInit },
  set $zendeskInit(value) { globalState.$zendeskInit = value },
  
  get $cdn() { return globalState.$cdn },
  set $cdn(value) { globalState.$cdn = value }
}

export default {
  getGlobal,
  setGlobal,
  getAllGlobals,
  setMultipleGlobals,
  getBroadcastChannel,
  getSegment,
  getLiveAgent, 
  getZendeskInit,
  getCdn,
  setBroadcastChannel,
  setSegment,
  setLiveAgent,
  setZendeskInit,
  setCdn,
  GlobalVars
}